import React from "react";
import { Column } from "@/components/Datatable/types";
import { CampaignStatusItem } from "@/modules/administration/features/Stochastic/CampaignStatus/api/fetchCampaignStatus/types";
import { format } from "date-fns";
import { Badge } from "@/components/ui/badge";

const getStatusColor = (statusName: string): string => {
  switch (statusName.toLowerCase()) {
    case "active":
      return "bg-green-100 text-green-700 border-transparent";
    case "completed":
      return "bg-blue-100 text-blue-700 border-transparent";
    case "pending":
      return "bg-yellow-100 text-yellow-700 border-transparent";
    case "paused":
      return "bg-yellow-100 text-yellow-700 border-transparent";
    case "archived":
      return "bg-gray-300 text-gray-600 border-transparent";
    default:
      return "bg-gray-100 text-gray-700 border-transparent";
  }
};

const formatDate = (dateStr: string | undefined): string => {
  if (!dateStr) return "-";
  try {
    return format(new Date(dateStr), "MM/dd/yyyy");
  } catch {
    return dateStr;
  }
};

export function subscriptionBillingColumns(): Column<CampaignStatusItem>[] {
  return [
    {
      id: "select",
      header: "",
      cell: () => (
        <input className="h-4 w-4 cursor-pointer" type="checkbox" readOnly />
      ),
    },
    {
      id: "name",
      header: "Campaign Name",
      accessorKey: "name",
      enableSorting: true,
      cell: ({ row }) => row.original.name || "-",
    },
    {
      header: "Company Name",
      accessorKey: "company",
      cell: ({ row }) => row.original.company.name || "-",
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      cell: ({ row }) => row.original.company.intacctId || "-",
    },
    {
      id: "description",
      header: "Description",
      accessorKey: "description",
      enableSorting: true,
      cell: ({ row }) => row.original.description || "-",
    },
    {
      id: "startDate",
      header: "Start Date",
      accessorKey: "startDate",
      enableSorting: true,
      cell: ({ row }) => formatDate(row.original.startDate),
    },
    {
      id: "endDate",
      header: "End Date",
      accessorKey: "endDate",
      enableSorting: true,
      cell: ({ row }) => formatDate(row.original.endDate),
    },
    {
      header: "Status",
      accessorKey: "campaignStatus",
      cell: ({ row }) => {
        const statusName = row.original.campaignStatus?.name;
        if (!statusName) return "-";
        return (
          <Badge className={getStatusColor(statusName)}>{statusName}</Badge>
        );
      },
    },
  ];
}
